import React from "react";
import { TAKING_BREAK_AREA } from "../../../test-identifiers";

export const TakeBreakIndicator = () => (
  <div className="breakContainer" data-testid={TAKING_BREAK_AREA}>
    <div className="breakIndicator" />
  </div>
);
